var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99994 7.375C9.38065 7.375 10.4999 6.25571 10.4999 4.875C10.4999 3.49429 9.38065 2.375 7.99994 2.375C6.61923 2.375 5.49994 3.49429 5.49994 4.875C5.49994 6.25571 6.61923 7.375 7.99994 7.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 13.1875C2.375 10.3916 4.64156 8.12503 7.4375 8.12503H8.5625C11.3584 8.12503 13.625 10.3916 13.625 13.1875V13.25C13.625 13.4571 13.4571 13.625 13.25 13.625C13.0429 13.625 12.875 13.625 12.875 13.625C12.875 13.625 10.9442 13.625 8.5625 13.625H7.4375C5.05577 13.625 3.125 13.625 3.125 13.625C3.125 13.625 2.95711 13.625 2.75 13.625C2.54289 13.625 2.375 13.4571 2.375 13.25V13.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.abd73175fe5a911a17fc11e664fa6283.svg";
export { ForwardRef as ReactComponent };